import { render, staticRenderFns } from "./AdminInfoMaintenance.vue?vue&type=template&id=0b034f7a&"
import script from "./AdminInfoMaintenance.vue?vue&type=script&lang=ts&"
export * from "./AdminInfoMaintenance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports